<style>

.list{
  display: grid;
  grid-template-columns: 30px auto;
  margin-top: 10px;
}
.list-check{
  grid-column: 1;
}
.list-text{
  grid-column: 2;
}

</style>

{#each items as item}
<div class="list" on:click="{ () => { select(item) } }">
  <div class="list-check">
    {#if item.selected}
      <i class="icon-check"></i>
    {/if}
  </div>
  <div class="list-text">
    {item.text}
  </div>
</div>
{/each}


<script>

export let items = [
  {text: "Popular", selected: true},
  {text: "New", selected: false},
  {text: "My Interests", selected: false},
  {text: "All", selected: false},
];


function select(item) {
  for (let i in items) {
    items[i].selected = false;
  }
  
  item.selected = true;
}

</script>